module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"请输入您的信息。","submit":"寻找尺码","height":{"labelName":"身高","labelUnit":"cm","placeholder":"身高","error":"请输入 130 到 210 之间的数字。"},"weight":{"labelName":"体重","labelUnit":"kg","placeholder":"体重","error":"请输入 20 到 150 之间的数字。"},"preferred_fit":{"title":"您想以什么版型穿这件衣服？","options":{"slim":"修身版型 - 贴合身体的紧身版型","basic":"基本版型 - 忠于基本的标准版型","loose":"宽松版型 - 宽裕舒适的版型"}}}}')
  delete Component.options._Ctor
}
